module.exports = __webpack_public_path__ + "img/default-nav-subnav-kia.01968f84.png";